<template>
  <NavigationComponent :activeTag="$t('app_features.live')">
    <CameraItemLayout>
      <template #contentLeft>
        <div>
          <div v-if="loading" class="loadingCard is-loading pt-4">
            <div
              class="image group block w-full aspect-w-4 aspect-h-3 bg-gray-50 overflow-hidden"
            />
          </div>
        </div>
        <LiveBase :cameraId="$route.params.camera_id" />
      </template>
    </CameraItemLayout>
  </NavigationComponent>
  <LiveSwitch />
</template>

<script>
import { segmentAnalytics } from "@/assets/scripts";
import CameraItemLayout from "@/views/camera/partials/CameraItemLayout.vue";
import NavigationComponent from "@/views/partials/NavigationComponent";
import LiveBase from "@/views/partials/components/LiveBase.vue";
import LiveSwitch from "@/views/partials/components/LiveSwitch.vue";

export default {
  name: "Live",
  components: {
    LiveSwitch,
    NavigationComponent,
    CameraItemLayout,
    LiveBase,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    segmentAnalytics("Live Visit");
  },
};
</script>
